import React, { useCallback, useState, useRef, RefObject } from 'react';
import { GqlDispensaries } from 'types/graphql';

import { useHeader } from 'src/dispensary/core-menu/components/header/use-header';

import SvgChevronIcon from 'src/assets/chevron-icon';
import MenuDrawer from 'src/dispensary/core-menu/components/core-menu-header/menu-drawer';
import { CartButton } from 'src/dispensary/core-menu/components/header/cart-button';
import { UserButton } from 'src/dispensary/core-menu/components/header/user-button';
import { Search } from 'src/dispensary/core-menu/components/header/search';
import { LoginNudge } from 'src/dispensary/core-menu/components/header/login-nudge';

import { HeaderContainer, HeaderWrapper, MenuButton, UtilityNav } from './mobile-header.styles';

type MobileHeaderProps = {
  dispensary: GqlDispensaries;
  isAccountEnabled: boolean;
};

export const MobileHeader = ({ dispensary, isAccountEnabled }: MobileHeaderProps): JSX.Element => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [userButtonRef, setUserButtonRef] = useState<RefObject<HTMLButtonElement> | null>(null);
  const utilityNavRef = useRef<HTMLDivElement>(null);
  const { trackEvent } = useHeader();

  const handleOpenClick = useCallback((): void => {
    setIsDrawerOpen(true);
    trackEvent('open menu');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseClick = useCallback((): void => {
    setIsDrawerOpen(false);
    trackEvent('close menu');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <HeaderWrapper data-testid='navigation'>
      <HeaderContainer>
        <MenuButton onClick={handleOpenClick}>
          <SvgChevronIcon height='7px' width='12px' />
          Menu
        </MenuButton>
        <MenuDrawer dispensary={dispensary} open={isDrawerOpen} onClose={handleCloseClick} />

        <Search />

        <UtilityNav ref={utilityNavRef}>
          {isAccountEnabled && <UserButton onRef={setUserButtonRef} />}
          <CartButton />

          {isAccountEnabled && <LoginNudge anchorEl={userButtonRef} containerRef={utilityNavRef} />}
        </UtilityNav>
      </HeaderContainer>
    </HeaderWrapper>
  );
};
